import _ from 'lodash';
import React, { useMemo } from 'react';
import { CustomerPortalWidget } from 'api/customer-portal/types';
import { CpCurvedRectangleWidgetDivider } from './cp-curved-rectangle-widget-divider';
import { CpPointedDivider } from './cp-pointed-divider';
import { CpRectangleWidgetDivider } from './cp-rect-widget-divider';
import { CpRectWithShorterRightVertex } from './cp-rect-with-shorter-right-vertex';
import { CpRoundedRectangleWidgetDivider } from './cp-rounded-rectangle-widget-divider';
import { CpDividerType } from './types';

export interface CpWidgetDidiverProps {
  nextWidget?: CustomerPortalWidget;
  widget: CustomerPortalWidget;
}

export const CpWidgetDivider: React.FC<CpWidgetDidiverProps> = ({
  widget,
  nextWidget,
}) => {
  const dividerType = useMemo(() => {
    return widget?.widgetDefinition?.styles?.dividerType;
  }, [widget?.widgetDefinition?.styles?.dividerType]);

  if (!dividerType) {
    return <></>;
  }

  switch (dividerType) {
    case CpDividerType.Rectangle:
      return (
        <CpRectangleWidgetDivider widget={widget} nextWidget={nextWidget} />
      );

    case CpDividerType.RoundedRectangle:
      return (
        <CpRoundedRectangleWidgetDivider
          widget={widget}
          nextWidget={nextWidget}
        />
      );

    case CpDividerType.RectangleWithAShorterRightVertex:
      return (
        <CpRectWithShorterRightVertex widget={widget} nextWidget={nextWidget} />
      );

    case CpDividerType.CurvedRectangle:
      return (
        <CpCurvedRectangleWidgetDivider
          widget={widget}
          nextWidget={nextWidget}
        />
      );

    case CpDividerType.PointedShape:
      return <CpPointedDivider widget={widget} nextWidget={nextWidget} />;
    default:
      return <></>;
  }
};
